module.exports = __webpack_public_path__ + "static/media/tiny4.f4db56bc.png";